var map = {
	"./campaigns.svg": 66,
	"./cross.svg": 211,
	"./email.svg": 101,
	"./ico_cross.svg": 102,
	"./login_logo.svg": 212,
	"./logo.svg": 50,
	"./logo_min.svg": 98,
	"./logout.svg": 103,
	"./magnifying-glass.svg": 104,
	"./menu.svg": 213,
	"./menu_close.svg": 100,
	"./menu_open.svg": 99,
	"./report.svg": 214,
	"./sms.svg": 105,
	"./target_audience.svg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;